var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("loading-anim", {
        attrs: { active: _vm.$store.state.loading, fullScreen: "" }
      }),
      _vm._v(" "),
      !_vm.$uiHelpers.isXlDevice
        ? _c(
            "b-navbar",
            {
              class: { navbar: true, "fixed-scroll": _vm.isFixedScrolled },
              attrs: { toggleable: "xl" }
            },
            [
              _c(
                "b-navbar-nav",
                { staticClass: "ml-auto" },
                [
                  _c(
                    "b-nav-item",
                    { staticClass: "ml-2" },
                    [
                      _c(
                        "base-button",
                        {
                          staticClass: "btn-layout",
                          on: { click: _vm.manageMenu }
                        },
                        [
                          _c("base-icon", {
                            staticStyle: { color: "#3238C4" },
                            attrs: {
                              src:
                                "/static-appopensalud/img/icons/morillas-svg-icons/primary/menu-icon.svg",
                              width: "23",
                              height: "23",
                              color: "#3238C4"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "router-link",
                { attrs: { to: "/" } },
                [
                  _c("b-navbar-brand", [
                    _c("img", {
                      staticClass: "navbar-brand-img",
                      staticStyle: { color: "#3238C4" },
                      style: _vm.getLogoStyles,
                      attrs: { color: "#3238C4", src: _vm.getLogo }
                    })
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-navbar-nav",
                { staticClass: "ml-auto" },
                [
                  _c(
                    "b-nav-item",
                    { staticClass: "mr-2" },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/inicio-sesion" } },
                        [
                          _c(
                            "base-button",
                            { staticClass: "btn-layout" },
                            [
                              _c("base-icon", {
                                attrs: {
                                  src:
                                    "/static-appopensalud/img/icons/morillas-svg-icons/primary/profile.svg",
                                  color: "#3238C4",
                                  svgClasses: "reverse"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("router-view", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var Component = ref.Component
                  return [
                    _c(
                      "transition",
                      { attrs: { name: "fade", mode: "out-in" } },
                      [_c(Component, { tag: "component" })],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d4b530ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4b530ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/PublicMobileMenuLayout.vue
// module id = 2112
// module chunks = 116